import React, { useEffect } from "react";
import { animate, useMotionValue, useTransform } from "framer-motion";
import { MotionText } from "ui/chakra-motion";

type KeyValueProps = {
  isInView?: boolean;
  animationDuration: number;
  animationDelay: number;
  valueStart: number;
  valueEnd: number;
};

export function KeyValue({ isInView, animationDuration, animationDelay, valueStart, valueEnd }: KeyValueProps) {
  const motionValue = useMotionValue(valueStart);
  const formattedValue = useTransform(motionValue, (value) => Math.round(value).toLocaleString());

  useEffect(() => {
    const animation = animate(motionValue, isInView ? valueEnd : valueStart, {
      delay: isInView ? animationDelay : 0,
      duration: isInView ? animationDuration : 0.05,
    });

    return animation.stop;
  }, [motionValue, valueStart, valueEnd, isInView, animationDuration, animationDelay]);

  return (
    <MotionText fontWeight="bold" fontSize={{ base: "brand.lg", lg: "brand.xl" }} mt="smallest">
      {formattedValue}
    </MotionText>
  );
}
